import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { authApi } from '../services/api';

const useAuthStore = create(
    persist(
        (set, get) => ({
            user: null,
            permissions: [],
            isAuthenticated: false,
            isLoading: false,
            error: null,

            login: async (email, password) => {
                set({ isLoading: true, error: null });
                try {
                    const res = await authApi.login({ email, password });
                    const { user, accessToken, refreshToken, permissions } = res.data.data;

                    localStorage.setItem('accessToken', accessToken);
                    localStorage.setItem('refreshToken', refreshToken);

                    set({
                        user,
                        permissions,
                        isAuthenticated: true,
                        isLoading: false
                    });
                    return { success: true };
                } catch (error) {
                    set({
                        isLoading: false,
                        error: error.response?.data?.error?.message || 'Login failed'
                    });
                    return { success: false, error: error.response?.data?.error?.message };
                }
            },

            logout: async () => {
                try {
                    await authApi.logout();
                } catch (e) {
                    console.log('Logout error', e);
                }
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                set({ user: null, permissions: [], isAuthenticated: false });
            },

            checkAuth: async () => {
                const token = localStorage.getItem('accessToken');
                if (!token) {
                    set({ isAuthenticated: false });
                    return false;
                }
                try {
                    const res = await authApi.getMe();
                    set({
                        user: res.data.data.user,
                        permissions: res.data.data.permissions || [],
                        isAuthenticated: true
                    });
                    return true;
                } catch {
                    set({ user: null, permissions: [], isAuthenticated: false });
                    return false;
                }
            },

            hasPermission: (permission) => {
                const { permissions } = get();
                return permissions.includes(permission);
            },

            hasAnyPermission: (perms) => {
                const { permissions } = get();
                return perms.some(p => permissions.includes(p));
            }
        }),
        {
            name: 'auth-storage',
            partialize: (state) => ({
                user: state.user,
                permissions: state.permissions,
                isAuthenticated: state.isAuthenticated
            })
        }
    )
);

export default useAuthStore;
